import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LeadFormComponent } from 'src/app/modules/lead-managment/add/lead-form.component';

@Component({
  selector: 'app-lead-option',
  templateUrl: './lead-option.component.html',
  styleUrls: ['./lead-option.component.scss'],
})
export class LeadOptionComponent implements OnInit {

  constructor(
    private _modalController: ModalController
  ) { }

  ngOnInit() { }

  
}
